import React from "react";

const ContactForm = () => {
  return (
    <div
      className="z-30 relative bg-cover bg-center"
      style={{ backgroundImage: "url('/bg-contact.jpg')" }}
    >
      <h1 className="text-4xl md:text-5xl font-bold text-[#111010] text-center py-10 animate-fadeIn">
        Contact <span className="text-[#ae0c00] italic">Us</span>
      </h1>

      <div className="flex flex-col md:flex-row h-auto p-6 md:p-10 animate-fadeIn">
        <div className="bg-white flex flex-col md:flex-row w-full rounded-2xl shadow-lg">
          {/* Left section: Form */}
          <div className="flex-1 bg-white p-6 md:p-10 lg:p-16 flex flex-col justify-center rounded-2xl">
            <h2 className="text-2xl md:text-3xl text-gray-900 font-bold mb-4">
              Chat to our team
            </h2>
            <p className="text-gray-600 mb-8">
              Need help with something? Want a demo? Get in touch with our
              friendly team and we'll get in touch within 2 hours.
            </p>

            <form className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input
                  type="text"
                  placeholder="First name"
                  className="border p-4 rounded-lg w-full outline-none focus-within:border-[#ae0c00] transition-all duration-300"
                />
                <input
                  type="text"
                  placeholder="Last name"
                  className="border p-4 rounded-lg w-full outline-none focus-within:border-[#ae0c00] transition-all duration-300"
                />
              </div>

              <input
                type="text"
                placeholder="Job title"
                className="w-full border p-4 rounded-lg outline-none focus-within:border-[#ae0c00] transition-all duration-300"
              />
              <input
                type="email"
                placeholder="Work email"
                className="w-full border p-4 rounded-lg outline-none focus-within:border-[#ae0c00] transition-all duration-300"
              />

              <div className="flex items-center border p-4 rounded-lg focus-within:border-[#ae0c00] transition-all duration-300">
                <input
                  type="tel"
                  placeholder="+91 9900049123"
                  className="flex-1 outline-none"
                />
              </div>

              <div>
                <p className="font-medium">Number of employees</p>
                <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 mt-4">
                  <button
                    type="button"
                    className="border-2 border-gray-300 p-4 rounded-lg w-full text-left flex items-center hover:border-[#ae0c00] transition-all duration-300"
                  >
                    <span role="img" aria-label="creator" className="mr-4">
                      👤
                    </span>
                    I'm a solo creator
                  </button>
                  <button
                    type="button"
                    className="border-2 border-gray-300 p-4 rounded-lg w-full text-left flex items-center hover:border-[#ae0c00] transition-all duration-300"
                  >
                    <span role="img" aria-label="team" className="mr-4">
                      👥
                    </span>
                    I'm part of a team
                  </button>
                </div>
              </div>

              <button className="bg-[#ae0c00] text-white p-4 rounded-lg w-full mt-4 hover:bg-[#ae0c00] transition-all duration-300">
                Get in touch
              </button>
            </form>
          </div>

          {/* Right section: Image with description */}
          <div className="flex-1 relative hidden md:block">
            <img
              src="/contact-us.jpg"
              alt="Contact Image"
              className="w-full h-full object-cover rounded-r-2xl"
            />
            <div className="absolute bottom-0 left-0 p-8 text-white bg-black bg-opacity-50 w-full text-left">
              <h3 className="text-lg font-semibold">Pals Infotech</h3>
              <p className="mt-2">
                Pals Infotech’s support team is known for its excellent and
                smooth service, providing quick and effective solutions to
                client issues. With a focus on personalized care, the team
                ensures seamless communication and efficient problem resolution,
                making sure clients feel valued and supported. Their expertise
                and dedication have earned them a reputation for delivering
                top-tier customer service
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
